/* eslint-disable react/jsx-props-no-spreading */
import { ReactElement } from 'react';
import { Container, Error, Input } from './styles';

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  sizeDisplay?: 'lg' | 'md' | 'sm';
  error?: boolean;
  errorMessage?: string;
  icon?: ReactElement;
  iconPosition?: 'right';
}

const StyledInput: React.FC<IProps> = ({
  sizeDisplay = 'lg',
  error = false,
  errorMessage = '',
  icon,
  iconPosition,
  ...rest
}) => (
  <Container sizeDisplay={sizeDisplay} iconPosition={iconPosition}>
    <Input error={error} {...rest} />
    {iconPosition === 'right' && icon}
    {error && errorMessage !== '' && <Error>{errorMessage}</Error>}
  </Container>
);

export { StyledInput };
